import type { OrderStatus } from '@rosita/shared';
import { t } from '../../i18n/pt';

/** Tailwind classes per order status. Uses the admin palette where it maps
 *  cleanly, and a few raw tints for the in-between states. */
const statusStyles: Record<OrderStatus, string> = {
  pending_payment: 'bg-amber-100 text-amber-800',
  payment_processing: 'bg-amber-100 text-amber-800',
  paid: 'bg-emerald-100 text-emerald-800',
  preparing: 'bg-sky-100 text-sky-800',
  shipped: 'bg-admin-powder text-admin-primary',
  delivered: 'bg-emerald-100 text-emerald-800',
  cancelled: 'bg-red-100 text-admin-danger',
  refunded: 'bg-admin-surface-alt text-admin-text-soft',
};

export function OrderStatusBadge({ status }: { status: OrderStatus }): JSX.Element {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${statusStyles[status]}`}
    >
      {t.orderStatus[status]}
    </span>
  );
}
